import React from 'react';
import { useTranslation } from 'react-i18next';

export default function LanguageSwitcher() {
  const { i18n } = useTranslation();

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  return (
    <div className="flex items-center gap-1 ml-4">
      <button
        onClick={() => changeLanguage('en')}
        className={`px-3 py-1 rounded text-sm font-medium transition-all duration-200 ${
          i18n.language === 'en'
            ? 'bg-vsred text-white shadow-red-glow'
            : 'text-gray-300 hover:text-white hover:bg-white/5'
        }`}
      >
        EN
      </button>
      <button
        onClick={() => changeLanguage('pl')}
        className={`px-3 py-1 rounded text-sm font-medium transition-all duration-200 ${
          i18n.language === 'pl'
            ? 'bg-vsred text-white shadow-red-glow'
            : 'text-gray-300 hover:text-white hover:bg-white/5'
        }`}
      >
        PL
      </button>
    </div>
  );
}